export default __webpack_public_path__ + "static/media/pavel-kosov.59118e6c.jpg";